// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"383":"00031098","385":"bd122174","956":"df687f15"}[chunkId] + ".css";
};